import LazyLoad from 'vanilla-lazyload';

export default class LazyLoadImage {
  execute(className) {
    var lazyLoadInstance = new LazyLoad({
      elements_selector: className,
      threshold: 300 // pixels before image comes into view
    });
  }
}
